export const TYPOGRAPHY_SIZE = {
    DISPLAY: 34,
    SECTION: 20,
    LABEL: 16,
    BODY: 14,
    ACCORDION_BODY: 14,
    PRODUCT_TITLE_PDP: 18,
    PRODUCT_TITLE_COMPACT: 14,
    ACCORDION_CONTENT_H1: 15,
    ACCORDION_CONTENT_H2: 14,
    ACCORDION_CONTENT_H3: 13,
} as const
